import { useContext } from "react";
import { InvestFormContext } from "./contexts/InvestFormContext";
import { InvestCalculationContext } from "./contexts/InvestCalculationContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestPaymentContext } from "./contexts/InvestPaymentContext";
import { convertToIndianFormat } from "../../../../utils/functions";
import { Stack, Typography, Divider, Box } from "@mui/material";
import { DividerComponent } from "../../../../components/miniComponents";
import CustomIcon from "../../../../components/customIcon";
import { AccInformation } from "./accInformation";
import { NoteComponent } from "./noteComponent";
import { TimerComponent } from "./timerComponent";

export const PaymentDetails = ({ inModal }) => {
  const { amount, amountAfterDiscount, founderCircleRewordTokens, founderCircleRewordConditions, founderCircleInvestor } = useContext(InvestFormContext);
  const { NoFrax, fraxWithoutDisc, selectDiscount, couponCashback, highValueCashback, setHighValueCashback, discRPF, costFrax, crossedAmount } = useContext(InvestCalculationContext);
  const { transaction, listing, user } = useContext(InvestTransactionContext);
  const { amtPaid, pendingAmt, amtTobePaid, isFullPayment } = useContext(InvestPaymentContext);
  const isSelectUser = user?.membershiptype === "SELECT";

  if (amount && amount >= 500000) setHighValueCashback(Math.floor(NoFrax / 144) * 20);
  const founderCircleReword = Math.floor(amount / founderCircleRewordConditions);
  const rewordTokens = founderCircleReword * founderCircleRewordTokens;
  return (
    <Stack spacing={4}>
      <Stack spacing={"10px"}>
        {isSelectUser && selectDiscount > 0 && fraxWithoutDisc !== NoFrax && (
          <>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="body3">
                Number of{" "}
                {`${listing?.assetClass?.tokenName ? listing?.assetClass?.tokenName.toUpperCase() : "FRAX"}`}{" "}
                Without Discount
              </Typography>
              <Typography variant="body3" sx={{ fontWeight: 500 }}>
                {convertToIndianFormat(fraxWithoutDisc, false) || "-"}
              </Typography>
            </Stack>
            <Divider />
          </>
        )}
        <Stack direction={"row"} justifyContent={"space-between"}>
          {selectDiscount > 0 &&
            isSelectUser &&
            fraxWithoutDisc !== NoFrax ? (
            <Typography variant="body3">
              Number of{" "}
              {`${listing?.assetClass?.tokenName ? listing?.assetClass?.tokenName.toUpperCase() : "FRAX"}`}{" "}
              With Discount
            </Typography>
          ) : (
            <Typography variant="body3">
              Number of{" "}
              {`${listing?.assetClass?.tokenName ? listing?.assetClass?.tokenName.toUpperCase() : "FRAX"}`}
            </Typography>
          )}
          <Typography variant="body3" sx={{ fontWeight: 500 }}>
            {convertToIndianFormat(NoFrax, false) || "-"}
          </Typography>
        </Stack>
        <Divider />
        {founderCircleInvestor && founderCircleRewordConditions > 0 &&
          founderCircleRewordTokens > 0 && (
            <>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="body3">Founder Circle Reword</Typography>
                <Typography variant="body3" sx={{ fontWeight: 500 }}>
                  {convertToIndianFormat(rewordTokens, false) || "-"} {""}
                  {listing?.assetClass?.tokenName ? listing?.assetClass?.tokenName.toUpperCase() : "FRAX"}
                </Typography>
              </Stack>
              <Divider />
            </>
          )}
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ color: !isSelectUser ? "#BDBDBD" : "" }}
        >
          <Stack direction={"row"} alignItems={"center"}>
            <Typography variant="body3">
              Select Membership Discount
            </Typography>
            <CustomIcon
              name="sale"
              sx={{
                width: "30px",
                height: "22px",
                bgcolor: !isSelectUser ? "#BDBDBD" : "success.main",
                marginLeft: 2,
              }}
            />
          </Stack>
          {selectDiscount ? (
            <Typography
              variant="body3"
              sx={{
                fontWeight: 500,
                color: !isSelectUser ? "#BDBDBD" : "error.main",
              }}
            >
              - {convertToIndianFormat(selectDiscount)}
            </Typography>
          ) : (
            "-"
          )}
        </Stack>
        <Divider />

        {/* <Stack direction={"row"} justifyContent={"space-between"}>
                    <Typography variant="body3">High Value Order Cashback</Typography>
                    <Typography variant="body3" sx={{fontWeight:500}}>{convertToIndianFormat(highValueCashback) ||"-"}</Typography>
                    <Typography variant="body3" sx={{ fontWeight: 500 }}>{"-"}</Typography>
                </Stack>
                <Divider /> */}

        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography variant="body3">Referal Cashback</Typography>
          <Typography variant="body3" sx={{ fontWeight: 500 }}>
            {convertToIndianFormat(couponCashback) || "-"}
          </Typography>
        </Stack>
        <Divider />
        {!transaction?.newpaymentMade && (
          <>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Typography variant="body3">Amount To be Paid Now</Typography>
              <Typography variant="body3" sx={{ fontWeight: 500 }}>
                {convertToIndianFormat(Math.round(amtTobePaid)) || "-"}
              </Typography>
            </Stack>
            <Divider />
          </>
        )}
        {transaction?.status != "CREATED" &&
          transaction?.payments?.length > 0 && (
            <>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="body3">Amount Paid</Typography>
                <Typography variant="body3" sx={{ fontWeight: 500 }}>
                  {convertToIndianFormat(Math.round(amtPaid)) || "-"}
                </Typography>
              </Stack>
              <Divider />
            </>
          )}
        {transaction?.status == "PARTPAID" &&
          transaction?.newpaymentMade &&
          transaction?.payments?.length > 0 && (
            <>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="body3">
                  Recent Payment (Approval Pending)
                </Typography>
                <Typography variant="body3" sx={{ fontWeight: 500 }}>
                  {convertToIndianFormat(
                    Math.round(
                      transaction?.payments[transaction?.payments?.length - 1]
                        ?.amountTransferred,
                    ),
                  ) || "-"}
                </Typography>
              </Stack>
              <Divider />
            </>
          )}
        {(!transaction ||
          transaction?.status == "CREATED" ||
          transaction?.newpaymentMade) && (
            <>
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Typography variant="body3">Payment Later</Typography>
                <Typography variant="body3" sx={{ fontWeight: 500 }}>
                  {!transaction
                    ? convertToIndianFormat(Math.round(pendingAmt))
                    : transaction?.status == "CREATED"
                      ? convertToIndianFormat(
                        Math.round(amount - amtTobePaid - selectDiscount),
                      )
                      : convertToIndianFormat(Math.round(pendingAmt))}
                </Typography>
              </Stack>
              <Divider />
            </>
          )}

        {/* {(transaction?.status == "CREATED") && <><Stack direction={"row"} justifyContent={"space-between"}>
                    <Typography variant="body3">Payment Later</Typography>
                    <Typography variant="body3" sx={{ fontWeight: 500 }}>{convertToIndianFormat(Math.round(amount - amtTobePaid)) || "-"}</Typography>
                </Stack>
                    <Divider /></>} */}

        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="body3">Total Investment Amount</Typography>
          {amount && NoFrax && (amtPaid || amtTobePaid) ? (
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="body3" sx={{ fontWeight: 500 }}>
                {convertToIndianFormat(Number(amountAfterDiscount))}
              </Typography>

              {selectDiscount > 0 && (
                <Typography sx={{ pl: 2, fontWeight: 500, color: "#878787" }}>
                  <span>
                    <span
                      style={{
                        textDecoration: "line-through",
                        textDecorationThickness: "0.8px",
                        fontSize: "15px",
                      }}
                    >
                      {convertToIndianFormat(Math.ceil(crossedAmount))}
                    </span>
                  </span>
                </Typography>
              )}
            </Stack>
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 600 }}>
              -
            </Typography>
          )}
        </Stack>
      </Stack>
      {(transaction?.status == "CREATED" || inModal) && (
        <>
          <Box>
            <DividerComponent />
          </Box>
          <AccInformation />
          {!transaction && <NoteComponent />}
          {transaction?.paymentMethod == "DBT" && <>
            <Box>
              <DividerComponent />
            </Box>
            {<TimerComponent />}
            {!inModal && <NoteComponent />}
          </>}
        </>
      )}
      {/* {
                transaction?.status=="PARTPAID" && 
                <>
                    <AccInformation />
                    <NoteComponent />
                </>
            } */}
    </Stack>
  );
}